/**
 * Returns the public image URL for a destination IATA code.
 * If the image does not exist, the <img> tag should fall back via `onError`.
 *
 * @param iataCode - The 3-letter destination airport code (e.g., "BUD")
 * @returns string - URL path to the image in the public folder
 */
export const getImageUrl = (iataCode: string): string => {
  return `/images/destinations/list_short/${iataCode}.png`;
};

/**
 * Returns the public image URL for a destination IATA code.
 * If the image does not exist, the <img> tag should fall back via `onError`.
 *
 * @param iataCode - The 3-letter destination airport code (e.g., "BUD")
 * @returns string - URL path to the image in the public folder
 */
export const getCardImageUrl = (iataCode: string): string => {
  return `/images/destinations/card/${iataCode}.png`;
};

/**
 * Returns the public image URL for a destination header background.
 * If the image does not exist, it should fall back via CSS or onError handling.
 *
 * @param iataCode - The 3-letter destination airport code (e.g., "BUD")
 * @returns string - URL path to the header background image
 */
export const getDestinationGroupHeaderURL = (iataCode: string): string => {
  return `/images/destinations/long/${iataCode}.png`;
};

